import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    // Parse options from data-swiper-options attribute
    const userOptions = this.optionsValue || {};

    // Default Swiper configuration
    const defaultOptions = {
      modules: [Autoplay],
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    };

    // Merge user options with defaults
    const options = { ...defaultOptions, ...userOptions };

    // Initialize Swiper
    this.swiper = new Swiper(this.element, options);
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}
